





































































































import Vue from 'vue';

export default Vue.extend({
  name: 'NavigationHeader',
  computed: {
    landingPageHost(): string {
      let url = process.env.LANDING_PAGE_URL || '';
      const currentLocale = this.$i18n.locale();
      // NB! Landing page vue router is using history mode, no need to add `/#/`
      if (currentLocale) url += `?locale=${currentLocale}`
      return url;
    },
    landingPageSetupAppURI(): string {
      return `${this.landingPageHost}/setup-app`;
    },
    landingPageHowToInstallURI(): string {
      return `${this.landingPageHost}/how-to-install`;
    },
  },
});
